import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as supplierActions from '../../../../../actions/supplierAction';
import * as SupplierCategoryAction from '../../../../../actions/supplierCategoryAction';
import SupplierProductDetail from './SupplierProductDetail';
import { getAllHotelActive } from "actions/hotelAction";

const mapStateToProps = state => {
    return {
        supplierState: state.supplierReducer,
        supplierCategoryState: state.supplierCategoryReducer,
        hotelState: state.hotelReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSuppliers: (params) => dispatch(supplierActions.getSupplierList(params)),
        getSupplierProductDetail: (supplierProduct) => dispatch(supplierActions.getSupplierProductDetail(supplierProduct)),
        getSupplierAll: () => dispatch(supplierActions.getSupplierListAll()),
        createSupplierProduct: (supplierProduct) => dispatch(supplierActions.createSupplierProductAction(supplierProduct)),
        updateSupplierProduct: (supplierProduct) => dispatch(supplierActions.updateSupplierProductAction(supplierProduct)),
        setSupplierProductDetail: (supplierProduct) => dispatch(supplierActions.setSupplierProductDetail(supplierProduct)),
        getSupplierCategoryListAll: () => dispatch(SupplierCategoryAction.getSupplierCategoryListAll()),
        getVinWonderTypes: () => dispatch(supplierActions.getVinwonderTypes()),
        getVinwonderRefIds: (params) => dispatch(supplierActions.getVinwonderRefIds(params)),
        setVinwonderRefIds: (data) => dispatch(supplierActions.setVinwonderRefIds({data: data})),
        getAllHotelActive: (params) => dispatch(getAllHotelActive(params))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SupplierProductDetail));